import { getEvents } from "@/api";
import { TableController } from "@/controllers/TableController";

/**
 * 全局事件日志表控制器
 */
export const globalEventLogTable = new TableController({
  loadMethod: getEvents,
  autoLoad: false,
  pageSize: 20,
  isClientPaged: true,
  keyField: "id",
  pageField: "offset",
  pageSizeField: "limit",
  queryParameters: {
    level: null,
    status: null,
  },
});

const state = {
  _pollingTimer: null,
};

const mutations = {
  SET_EVENT_LOG_PARAMETERS(state, params) {
    globalEventLogTable.setQueryParameters(params);
    globalEventLogTable.refresh();
  },
  SET_POLLING_TIMER(state, timer) {
    state._pollingTimer = timer;
  },
};

const getters = {
  eventLogTable: () => globalEventLogTable,
  list: () => {
    return globalEventLogTable.state.tableData;
  },
};

const actions = {
  startPolling({ commit }, interval) {
    const me = this;
    if (me._pollingTimer) return;
    const _pollingTimer = setInterval(() => {
      //判断没有登录就不执行
      if(localStorage.getItem("token") === null) {
        clearInterval(_pollingTimer);
        commit("SET_POLLING_TIMER", null);
        return;
      }
      
      if (process.env.NODE_ENV === "development") {
        globalEventLogTable.refresh();
        clearInterval(_pollingTimer);
        commit("SET_POLLING_TIMER", null);
      } else {
        globalEventLogTable.refresh();
      }
    }, interval);
  },
  stopPolling({ commit }) {
    const me = this;
    if (me._pollingTimer) {
      clearInterval(me._pollingTimer);
      commit("SET_POLLING_TIMER", null);
    }
  },
  updateQueryParameters({ commit }, params) {
    commit("SET_EVENT_LOG_PARAMETERS", params);
  },
  eventLogRefresh() {
    globalEventLogTable.refresh();
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
